import { Box, Tabs, Tab } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import SectionTitle from '../Shared/SectionTitle/SecctionTitle';
import CustomTabPanel from "./TabPanel/TabPanel";
import featureImage from '../../assets/images/graphic.png';
import classes from './FeaturesTab.module.css';

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
        className: classes.TabButton,
    };
}

const FeaturesTab = (props) => {
    const { t } = useTranslation();
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };
    return (
        <section>
            <div className="container">
                <SectionTitle subtitle={t('tabFeatures.subtitle')} title={t('tabFeatures.title')} />
                <Box sx={{ width: '100%' }}>
                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            aria-label="basic tabs example"
                            variant="scrollable"
                            scrollButtons
                            allowScrollButtonsMobile
                            sx={{
                                "& .MuiTab-root": {
                                    color: "gray !imprtant",
                                },
                                "& .Mui-selected": {
                                    color: "#bf2733 !important",
                                },
                                "& .MuiTabs-indicator": {
                                    backgroundColor: "#bf2733",
                                },
                            }}>
                            <Tab label={t('tabFeatures.tabs.tab1.title')} {...a11yProps(0)} />
                            <Tab label={t('tabFeatures.tabs.tab2.title')} {...a11yProps(1)} />
                            <Tab label={t('tabFeatures.tabs.tab3.title')} {...a11yProps(2)} />
                            <Tab label={t('tabFeatures.tabs.tab4.title')} {...a11yProps(3)} />
                            <Tab label={t('tabFeatures.tabs.tab5.title')} {...a11yProps(4)} />
                        </Tabs>
                    </Box>

                    <CustomTabPanel value={value} index={0}>
                        <div className="row">
                            <div className="col-8">
                                <h2>{t('tabFeatures.tabs.tab1.header')}</h2>
                                <ul>
                                    <li>{t('tabFeatures.tabs.tab1.item1')}</li>
                                    <li>{t('tabFeatures.tabs.tab1.item2')}</li>
                                    <li>{t('tabFeatures.tabs.tab1.item3')}</li>
                                </ul>
                            </div>
                            <div className="col-4">
                                <div className={classes.FeatureImage}>
                                    <img src={featureImage} alt="Red Taxi" data-aos="zoom-in" />
                                </div>
                            </div>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={1}>
                        <div className="row">
                            <div className="col-8">
                                <h2>{t('tabFeatures.tabs.tab2.header')}</h2>
                                <ul>
                                    <li>{t('tabFeatures.tabs.tab2.item1')}</li>
                                    <li>{t('tabFeatures.tabs.tab2.item2')}</li>
                                </ul>
                            </div>
                            <div className="col-4">
                                <div className={classes.FeatureImage}>
                                    <img src={featureImage} alt="Red Taxi" data-aos="zoom-in" />
                                </div>
                            </div>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={2}>
                        <div className="row">
                            <div className="col-8">
                                <h2>{t('tabFeatures.tabs.tab3.header')}</h2>
                                <ul>
                                    <li>{t('tabFeatures.tabs.tab3.item1')}</li>
                                    <li>{t('tabFeatures.tabs.tab3.item2')}</li>
                                </ul>
                            </div>
                            <div className="col-4">
                                <div className={classes.FeatureImage}>
                                    <img src={featureImage} alt="Red Taxi" data-aos="zoom-in" />
                                </div>
                            </div>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={3}>
                        <div className="row">
                            <div className="col-8">
                                <h2>{t('tabFeatures.tabs.tab4.header')}</h2>
                                <ul>
                                    <li>{t('tabFeatures.tabs.tab4.item1')}</li>
                                    <li>{t('tabFeatures.tabs.tab4.item2')}</li>
                                </ul>
                            </div>
                            <div className="col-4">
                                <div className={classes.FeatureImage}>
                                    <img src={featureImage} alt="Red Taxi" data-aos="zoom-in" />
                                </div>
                            </div>
                        </div>
                    </CustomTabPanel>
                    <CustomTabPanel value={value} index={4}>
                        <div className="row">
                            <div className="col-8">
                                <h2>{t('tabFeatures.tabs.tab5.header')}</h2>
                                <ul>
                                    <li>{t('tabFeatures.tabs.tab5.item1')}</li>
                                    <li>{t('tabFeatures.tabs.tab5.item2')}</li>
                                </ul>
                            </div>
                            <div className="col-4">
                                <div className={classes.FeatureImage}>
                                    <img src={featureImage} alt="Red Taxi" data-aos="zoom-in" />
                                </div>
                            </div>
                        </div>

                    </CustomTabPanel>
                </Box>
            </div>
        </section>
    );
}

export default FeaturesTab;